import { render, staticRenderFns } from "./gain.vue?vue&type=template&id=30a965f1&scoped=true&"
import script from "./gain.vue?vue&type=script&lang=js&"
export * from "./gain.vue?vue&type=script&lang=js&"
import style0 from "./gain.vue?vue&type=style&index=0&id=30a965f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a965f1",
  null
  
)

export default component.exports